import { TemplateSalaryItem } from '../bus/templateSalary/types';
import $axios from '../utils/axios-instance';

export default class TemplateSalarysApi {
  async getTemplateSalaryList() {
    return await $axios
      .get<{ data: TemplateSalaryItem[] }>('/v1/TemplateSalary')
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async getTemplateSalaryDetail(data: { id: number | string }) {
    return await $axios
      .get<TemplateSalaryItem>(`/v1/TemplateSalary/${data.id}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async createTemplateSalary(data: Omit<TemplateSalaryItem, 'id'>) {
    return await $axios
      .post('/v1/TemplateSalary', data)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async changeTemplateSalary(data: TemplateSalaryItem) {
    return await $axios
      .put(`/v1/TemplateSalary/${data.id}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async deleteTemplateSalary(data: { id: number | string }) {
    return await $axios
      .delete(`/v1/TemplateSalary/${data.id}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }
}
